import { ModelInfo } from '../types/models';

/**
 * Formats a cost value for display in USD.
 * Examples: "$2.50", "$0.15", "$0.05"
 */
function formatCost(cost: number): string {
  // Drop trailing zeros but keep at least one decimal for sub-dollar
  if (cost >= 1) return `$${cost}`;
  return `$${cost}`;
}

/**
 * Returns a display label for a model, optionally including token cost info.
 * Example: "GPT-5.4 (↑$2.50 | ↓$15)"
 */
export function modelDisplayLabel(model: ModelInfo, showCost: boolean = true): string {
  if (!showCost || (model.inputTokenCostPer1M == null && model.outputTokenCostPer1M == null)) {
    return model.displayName;
  }

  const parts: string[] = [];
  if (model.inputTokenCostPer1M != null) {
    parts.push(`↑${formatCost(model.inputTokenCostPer1M)}`);
  }
  if (model.outputTokenCostPer1M != null) {
    parts.push(`↓${formatCost(model.outputTokenCostPer1M)}`);
  }

  return parts.length > 0
    ? `${model.displayName} (${parts.join(' | ')})`
    : model.displayName;
}
